import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SnackbarComponent } from './snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  
 

  

  public openSnackBarSuccess(
    message: string | string[],
    onAction?: () => void,
    title?: string,
    messageIsHtml: boolean = false,
  ) {
    this.openSnackBar('success-snackbar', 'Success', message, title, onAction, messageIsHtml);
  }

  public openSnackBarFailure(
    message: string | string[],
    onAction?: () => void,
    title?: string,
    messageIsHtml: boolean = false,
    importantError: boolean = false,
  ) {
    this.openSnackBar(
      'failure-snackbar',
      'Failure',
      message,
      title,
      onAction,
      messageIsHtml,
      importantError,
      importantError,
    );
  }

  public openSnackBarInformation(
    message: string | string[],
    onAction?: () => void,
    title?: string,
    messageIsHtml: boolean = false,
  ) {
    this.openSnackBar(
      'information-snackbar',
      'Information',
      message,
      title,
      onAction,
      messageIsHtml,
    );
  }

  private openSnackBar(
    panelClass: string,
    snackbarType: string,
    message: string | string[],
    title?: string,
    onAction?: () => void,
    messageIsHtml: boolean = false,
    keepOpen: boolean = false,
    copyToClipboard: boolean = false,
  ) {
    const opts: MatSnackBarConfig<any> = {
      verticalPosition: 'bottom',
      panelClass: [panelClass],
      data: {
        message: message,
        title: title,
        snackbarType: snackbarType,
        clickable: !!onAction,
        messageIsHtml: messageIsHtml,
        copyToClipboard: copyToClipboard,
      },
    };
    if (keepOpen) {
      opts.duration = undefined;
    }
    const snackbarRef = this.snackBar.openFromComponent(SnackbarComponent, opts);
    const onActionSubscription = onAction ? snackbarRef.onAction().subscribe(onAction) : null;
    if (onAction) {
      const afterDismissedSubscription = snackbarRef.afterDismissed().subscribe(() => {
        onActionSubscription.unsubscribe();
        afterDismissedSubscription.unsubscribe();
      });
    }
  }
}
